import type { InitiativeBlock } from "@nnf3d/studio/types";
import type { PortableTextComponents } from "@portabletext/react";

import { Bullet } from "./bullet";
import { ContentCta } from "./content-cta";
import { ContentMedia } from "./content-media";
import { Heading } from "./heading";
import { Link } from "./link";
import { ListItem } from "./list-item";
import { Normal } from "./normal";
import { Number } from "./number";
import { Unknown } from "./unknown";

const components = {
	block: { h1: Heading, normal: Normal },
	list: { bullet: Bullet, number: Number },
	listItem: ListItem,
	marks: { link: Link },
	types: { contentMedia: ContentMedia, contentCta: ContentCta },
	unknownBlockStyle: Normal,
	unknownList: Bullet,
	unknownListItem: ListItem,
	unknownMark: Unknown,
	unknownType: Unknown,
} as const satisfies PortableTextComponents<InitiativeBlock[number]>;

export { components };
